<script>
import { deactivate, reactivate } from '../api/groups';

export default {
  name: 'CpStatusGroupDialog',
  components: {
    CpButton: require('../button').default,
    CpButtonLink: require('../button-link').default,
    CpDialog: require('../dialog').default,
    CpBoxContent: require('../box-content').default,
    CpBox: require('../box').default,
    CpTextInput: require('../inputs/text').default,
  },
  props: {
    handleDialog: Function,
    handleStatusGroup: Function,
    group: Object,
    isDeactivated: Boolean,
  },
  data() {
    return {
      loading: false,
      deactivateSuccess: false,
      reactivateSuccess: false,
      deactivateError: false,
      reactivateError: false,
      successText: this.isDeactivated ? 'Group reactivated successfully!' : 'Group deactivated successfully!',
      errorText: 'An error has occurred!',
    };
  },
  methods: {
    deactivateGroup() {
      if (!this.authUser) {
        window.location.href = '/user/login';
      } else {
        this.loading = true;
        deactivate(this.group.id)
          .then(response => {
            this.handleStatusGroup();
            this.loading = false;
            this.deactivateSuccess = true;
            this.group.moderation_state = response.group.moderation_state;
            setTimeout(() => {
              this.deactivateSuccess = false;
              this.handleDialog();
              window.location.href = '/groups/' + this.group.id;
            }, 3000);
          })
          .catch(error => {
            this.loading = false;
            this.deactivateError = true;
            console.warn(error);
          });
      }
    },
    reactivateGroup() {
      if (!this.authUser) {
        window.location.href = '/user/login';
      } else {
        this.loading = true;
        reactivate(this.group.id)
          .then(response => {
            this.handleStatusGroup();
            this.loading = false;
            this.reactivateSuccess = true;
            this.group.moderation_state = response.group.moderation_state;
            setTimeout(() => {
              this.reactivateSuccess = false;
              this.handleDialog();
            }, 3000);
          })
          .catch(error => {
            this.loading = false;
            this.reactivateError = true;
            console.warn(error);
          });
      }
    },
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
  },
};
</script>
<template>
  <cp-dialog>
    <cp-box class="dialogContainer">
      <cp-box-content>
        <section style="margin: 2em 2em">
          <template v-if="!deactivateSuccess && !deactivateError && !reactivateSuccess && !reactivateError" class="share-container">
            <h2 :class="{ 'black-color': true, textCenter: true, subheadline1: !$root.isMobile, headline: $root.isMobile }">
              {{ isDeactivated ? 'Are you sure you want to reactivate this group?' : 'Are you sure you want to deactivate this group?' }}
            </h2>
            <p v-if="isDeactivated" :class="{ 'neutral4-color': true, body: !$root.isMobile, body1: $root.isMobile }">
              Members will be able to interact with each other and the group again, and all the previous settings are maintained.
            </p>
            <div v-else>
              <p :class="{ 'neutral4-color': true, body: !$root.isMobile, body1: $root.isMobile }">
                If you disabled your group, members won’t be able to interact with each other and the group, but they will still see the content.
              </p>
            </div>
            <div class="btnContainer">
              <cp-button noborder @click="handleDialog()" :disabled="loading" block>Cancel</cp-button>
              <cp-button primary @click="isDeactivated ? reactivateGroup() : deactivateGroup()" block :loading="loading" :disabled="loading">{{
                isDeactivated ? 'Reactivate' : 'Deactivate'
              }}</cp-button>
            </div>
          </template>
          <template v-else-if="deactivateSuccess || reactivateSuccess">
            <div class="btnContainer">
              <i class="fas fa-check check-icon"></i>
            </div>
            <p :class="{ 'black-color': true, textCenter: true, subheadline1: !$root.isMobile, headline: $root.isMobile }">{{ successText }}</p>
          </template>
          <template v-else-if="deactivateError || reactivateError">
            <svg
              @click.prevent="handleDialog()"
              class="close-svg-icon"
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
              ></path>
            </svg>
            <div class="btnContainer">
              <i class="fas fa-times error-icon"></i>
            </div>
            <p :class="{ 'black-color': true, textCenter: true, subheadline1: !$root.isMobile, headline: $root.isMobile }">{{ errorText }}</p>
          </template>
        </section>
      </cp-box-content>
    </cp-box>
  </cp-dialog>
</template>
<style scoped>
.dialogContainer {
  max-width: 600px !important;
}
.close-svg-icon {
  cursor: pointer;
}
.share-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
}
.check-icon {
  font-size: 3em;
  color: var(--success);
}
.error-icon {
  font-size: 3em;
  color: red;
}
.btnContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.textCenter {
  text-align: center;
}
</style>
